'use strict';

var isEmpty = require('../lang/is-empty'),
    isString = require('../lang/is-string'),
    pl = /\+/g;  // Regex for replacing addition symbol with a space

/**
 * Effettua il decode di una stringa effettuando il replace degli simboli di addizione in spazi
 *
 * @param s
 * @returns {string}
 */
function decodeAndRemoveAdditions(s) {
    return decodeURIComponent(s.replace(pl, ' '));
}

/**
 * Metodo che data una querystring genera un oggetto
 * @param qs
 * @param removeAdditons
 * @returns {Object}
 */
module.exports = function getParams(qs, removeAdditons) {
    var result = {},
        decode = removeAdditons ? decodeAndRemoveAdditions : decodeURIComponent,
        pairList,
        pair,
        i;

    if (isString(qs) && !isEmpty(qs)) {
        pairList = qs.split('&');

        for (i = pairList.length - 1; i >= 0; i--) {
            pair = pairList[i].split('=');

            result[pair[0]] = decode(pair[1]);
        }
    }

    return result;
};
